
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hid]/gallery",
      function () {
        return require("private-next-pages/[hid]/gallery.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[hid]/gallery"])
      });
    }
  